import { BaseModal } from './BaseModal';
import { PrimaryButton } from './PrimaryButton';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  isLoading?: boolean;
  isDanger?: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  isLoading = false,
  isDanger = false,
}: ConfirmationModalProps) => {
  const footer = (
    <div className="flex gap-3 justify-end">
      <button
        onClick={onClose}
        disabled={isLoading}
        className="px-4 py-2 border border-gray-300 rounded-lg text-text hover:bg-gray-50 transition disabled:opacity-50"
      >
        {cancelText}
      </button>

      <PrimaryButton
        onClick={onConfirm}
        loading={isLoading}
        className={isDanger ? 'bg-red-600 hover:bg-red-700' : ''}
      >
        {confirmText}
      </PrimaryButton>
    </div>
  );

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title={title} footer={footer} maxWidth="md">
      <p className="text-secondary">{message}</p>
    </BaseModal>
  );
};
